// extracted by mini-css-extract-plugin
export var container = "VerticalShadowEgg-module--container--Jd8jZ";